import { gql } from '@apollo/client';
import AddressFragment from "../../fragments/Address";

const incomingOrders = gql`
  query IncomingOrders(
    $offset: Int!,
    $pageSize: Int!,
    $sortField: String!,
    $sortDesc: Boolean!,
    $searchTerm: String,
    $fromDate: DateTime,
    $toDate: DateTime,
    $deliveryDateFrom: DateTime,
    $deliveryDateTo: DateTime,
    $receiver: String,
    $deliveryAddress2: String,
    $reference: String,
    $deliveryZip: String,
    $city: String,
    $orderNo: String,
    $user: String,
    $costPlace: String,
    $supplierOrderNo: String
    $supplierOrderStatusId: Int
  ) {
    incomingOrdersContext {
      incomingOrders(
        model: {
          offset: $offset
          pageSize: $pageSize
          sortField: $sortField
          sortDesc: $sortDesc
          searchTerm: $searchTerm
          supplierOrderStatusId: $supplierOrderStatusId
          fromDate: $fromDate
          toDate: $toDate
          deliveryDateFrom: $deliveryDateFrom
          deliveryDateTo: $deliveryDateTo
          receiver: $receiver
          deliveryAddress2: $deliveryAddress2
          reference: $reference
          deliveryZip: $deliveryZip
          city: $city
          orderNo: $orderNo
          user: $user
          costPlace: $costPlace
          supplierOrderNo: $supplierOrderNo
        }
      ) {
        items {
          __typename
          supplierOrderId
          supplierOrderNo
			    orderReference
		  	  supplierOrderReference
	  		  orderConfirmationSent
  			  transportUpdateSent
          comment
          companyOrderno     
          orderingCompany
          costPlaceOrder
          costPlaceOrder2
          costPlaceOrder3          
          deliveryDateWish
          deliveryAddress {
            __typename
            ...AddressFields
          }
          invoiceAddress {
            __typename
            ...AddressFields
          }
          orderDate
          ordererAddress {
            #email
            __typename
            ...AddressFields
          }
          orderId
          status
          orderStatus
          sumInclVat
          username
          orderRows {
            __typename
            amount
            #articleNo
            #guid
            orderRowType
            price
            product
	  				#deliveryDateWish
  					#confirmedDeliveryDate
            stockInfo {
              __typename
              stockLocation
              picked
              pickedBy
            }
            weight
          }
        }
        totalResult
      }
    }
  }
  ${AddressFragment}
`;

export default incomingOrders;
